function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Icons Big/ic_complete");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Icons-Big/ic_complete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fillOpacity: 0.12,
  fill: "#29C76D",
  cx: 36,
  cy: 36,
  r: 35
}), /*#__PURE__*/React.createElement("g", {
  id: "icons8-ok",
  transform: "translate(7.862745, 7.862745)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.1372549,56.2745098 C12.6054902,56.2745098 0,43.6690196 0,28.1372549 C0,12.6054902 12.6054902,0 28.1372549,0 C43.6690196,0 56.2745098,12.6054902 56.2745098,28.1372549 C56.2745098,43.6690196 43.6690196,56.2745098 28.1372549,56.2745098 Z",
  id: "Path",
  fill: "#29C76D"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "23.6813378 40.1470588 13.3823529 29.8339949 16.5914569 26.6952364 23.6813378 33.8695417 41.7418764 15.7843137 44.9509804 18.9230723"
})));

var SvgIcComplete = function SvgIcComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_complete.83aed504.svg";
export { ForwardRef as ReactComponent };